import Model from "./base/model";

class ChatbotAllowedNumber extends Model{
  resourceName() {
    return "chatbot_allowed_numbers";
  }

  fields() {
    return {
      name: "",
      cellphone: "",
      company: { jsonApi: "hasOne", type: "companies"},
    };
  }

  findByCompanyId(companyId, params = {}, options = {}) {
    return this.request(
      "chatbot_allowed_numbers/company/" + companyId,
      "GET",
      params,
      null,
      null,
      options
    );
  }
}

export default new ChatbotAllowedNumber();

